import { CloseIcon } from '@raysee/icon';
import { FC, useEffect, useRef } from 'react';
import ModernDrawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';

interface Props {
  isOpen: boolean;
  placement: 'left' | 'right';
  onClose: () => void;
}

export const SpDrawer: FC<Props> = ({ isOpen, onClose, placement, children }) => {
  useEffect(() => {
    backfaceFixed(isOpen);
    document.body.style.overflowY = isOpen ? 'hidden' : 'scroll';
  }, [isOpen]);

  return (
    <div id="raysee_custom_drawer">
      <ModernDrawer open={isOpen} direction={placement} onClose={onClose} size={'80%'}>
        <div className="relative h-[calc(100%-51px)] bg-white" style={{ padding: '21px' }}>
          <a className="absolute z-10 cursor-pointer p-5" style={{ top: '-50px', right: '0px' }}>
            <CloseIcon width={22} height={22} />
          </a>
          <div>{children}</div>
        </div>
      </ModernDrawer>
    </div>
  );
};

const backfaceFixed = (fixed: boolean) => {
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.body.style.paddingRight = fixed ? `${scrollbarWidth}px` : '';
  const scrollingElement = () => {
    const browser = window.navigator.userAgent.toLowerCase();
    if ('scrollingElement' in document) return document.scrollingElement;
    if (browser.indexOf('webkit') > 0) return (document as Document).body;
    return (document as Document).documentElement;
  };
  const scrollY = fixed ? scrollingElement().scrollTop : parseInt(document.body.style.top || '0');
  const styles = {
    height: '100vh',
    left: '0',
    overflow: 'hidden',
    position: 'fixed',
    top: `${scrollY * -1}px`,
    width: '100vw',
  };
  Object.keys(styles).forEach((key) => {
    document.body.style[key] = fixed ? styles[key] : '';
  });
  if (!fixed) window.scrollTo(0, scrollY * -1);
};
